/**
 * @generated SignedSource<<6ed19731780bdad3d52e95d62b84f1a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueKeyCell$data = {
  readonly id: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "IssueKeyCell";
};
export type IssueKeyCell$key = {
  readonly " $data"?: IssueKeyCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueKeyCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "da780fe572d68360177cd1d738e295b6";

export default node;
